import { useSelector } from "react-redux";
import { chunkArray } from "@/components/shared/Hooks";
import { Box, Text } from "@quintoandar-tokko/jopijs";
import style from "./basicInformation.module.scss";
import Trans from "@/components/shared/Trans";
import translations from "../FichaInfo.trans.json";

export default function OperationsBlock() {
  const { origin_data } = useSelector((state) => state.FichaInfoSlice);

  if (!origin_data.operation_block_data?.length) return null;

  const operations = origin_data.operation_block_data
    ? chunkArray(origin_data.operation_block_data, 3)
    : [];

  return (
    <Box __css={{ marginTop: '40px' }}>
      <Text className={style.BITitle} variant="bodyBold.fontSize14">
        {Trans(translations, 'Operations')}
      </Text>

      {operations.length > 0 && (
        <Box
          className={style.infoCont}
          __css={{ marginBottom: '32px', color: 'var(--colors-neutral-grey-700)' }}
        >
          {operations.map((column, columnIndex) => (
            <Box key={columnIndex + 1} className={style.BIItems}>
              {column.map((item, index) => (
                <Text key={index} variant="body.fontSize14">
                  {item.name ? `${item.name}: ${item.value}` : item.value}
                </Text>
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
